<template>
  <div class="text-ontick-carbon-900 p-6 dark:text-gray-300">
    <div class="pb-6">
      <h2 class="text-3xl font-semibold">Vínculos</h2>
      <p class="text-sm">Administre todos os seus vínculos</p>
    </div>
    <div class="space-y-4">
      <div class="flex w-full justify-end">
        <ontick-button-component
          class="items-center space-x-2 py-2 px-2"
          @click.native="openModal"
        >
          <i v-html="$icons.plus"></i>
          <span>Solicitar vínculos</span>
        </ontick-button-component>
      </div>
      <div
        class="border-ontick-steel-300 dark:bg-ontick-graphite-500 rounded-xl border-2 bg-transparent dark:border-none"
      >
        <div class="p-6">
          <div class="flex w-full items-center space-x-2">
            <h3 class="whitespace-nowrap text-lg font-bold">Meus vínculos</h3>
            <div
              class="bg-ontick-steel-300 dark:bg-ontick-steel-500 h-[2px] w-full flex-grow"
            ></div>
          </div>
          <div
            class="text-ontick-carbon-900 py-4 text-center dark:text-gray-300"
            v-if="!bindings.filter((i) => i.binding_status === 'valid').length"
          >
            Nenhum vínculo ativo encontrado.
          </div>
          <div
            v-else
            class="grid grid-cols-1 gap-4 py-2 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4"
          >
            <div
              class="relative flex items-center space-x-4 rounded-lg p-4 transition"
              v-for="(item, index) in bindings.filter(
                (i) => i.binding_status === 'valid'
              )"
              :key="index"
            >
              <img
                :src="item.partner_logo"
                :alt="item.partner_name"
                class="img"
              />
              <div class="flex flex-col space-y-1">
                <span class="text-xs">{{
                  item.partner_type === "DEVELOPER"
                    ? "Desenvolvedor"
                    : item.partner_type === "ANALYST"
                    ? "Analista"
                    : item.partner_type === "AAI"
                    ? "AAI"
                    : "Gestor"
                }}</span>
                <span
                  class="text-sm leading-none lg:text-base lg:leading-tight"
                  >{{ item.partner_name }}</span
                >
                <button
                  class="text-ontick-red-600 hover:text-ontick-red-400 flex items-center space-x-1 text-xs transition-all"
                  @click="unbind(item.partner_name, item.binding_status)"
                >
                  <i v-html="$icons.delete_outline"></i>
                  <span>Desfazer</span>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="p-6">
          <div class="flex w-full items-center space-x-2">
            <h3 class="whitespace-nowrap text-lg font-bold">
              Vínculos solicitados
            </h3>
            <div
              class="bg-ontick-steel-300 dark:bg-ontick-steel-500 h-[2px] w-full flex-grow"
            ></div>
          </div>
          <div
            class="text-ontick-carbon-900 py-4 text-center dark:text-gray-300"
            v-if="
              !bindings.filter((i) => i.binding_status === 'pending').length
            "
          >
            Nenhuma solicitação de vínculo pendente encontrada.
          </div>
          <div
            v-else
            class="grid grid-cols-1 gap-4 py-2 sm:grid-cols-2 xl:grid-cols-4"
          >
            <div
              class="relative flex items-center space-x-4 rounded-lg p-4 transition"
              v-for="(item, index) in bindings.filter(
                (i) => i.binding_status === 'pending'
              )"
              :key="index"
            >
              <img
                :src="item.partner_logo"
                :alt="item.partner_name"
                class="img"
              />
              <div class="flex flex-col space-y-1">
                <span class="text-xs">{{
                  item.partner_type === "DEVELOPER"
                    ? "Desenvolvedor"
                    : item.partner_type === "ANALYST"
                    ? "Analista"
                    : item.partner_type === "AAI"
                    ? "AAI"
                    : "Gestor"
                }}</span>

                <span
                  class="whitespace-nowrap text-sm leading-none lg:text-base lg:leading-tight"
                  >{{ item.partner_name }}</span
                >
                <button
                  class="text-ontick-red-600 hover:text-ontick-red-400 flex items-center space-x-1 text-xs transition-all"
                  @click="unbind(item.partner_name, item.binding_status)"
                >
                  <i v-html="$icons.delete_outline"></i>
                  <span class="mt-px">Desfazer</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <portal to="modal">
      <ontick-modal-component
        :open="modalIsActive"
        @close="modalIsActive = false"
        class="text-gray-300"
      >
        <bindings-modal-content-component
          @confirm="confirmRequest"
          @close="modalIsActive = false"
        />
      </ontick-modal-component>
    </portal>
  </div>
</template>

<script>
import ontickButtonComponent from "../../../../shared/components/basic/ontick-button.component.vue";
import OntickInputComponent from "../../../../shared/components/basic/ontick-input.component.vue";
import OntickModalComponent from "../../../../shared/components/basic/ontick-modal.component.vue";
import ModalComponent from "../../../../shared/components/modal-account/modal.component.vue";
import BindingsModalContentComponent from "../../components/bindings-modal-content.component.vue";

export default {
  components: {
    ontickButtonComponent,
    ModalComponent,
    OntickModalComponent,
    OntickInputComponent,
    BindingsModalContentComponent,
  },
  data() {
    return {
      bindings: [],

      modalIsActive: false,
    };
  },
  methods: {
    confirmRequest() {
      this.modalIsActive = false;
      this.getBindings();
    },
    openModal() {
      this.modalIsActive = true;
    },
    unbind(name, status) {
      this.$swal({
        title: "Desfazer vínculo",
        text: "Ao desfazer este vínculo você perde acesso a todas as estratégias e serviços oferecidos por este parceiro. Deseja continuar?",
        showConfirmButton: false,
        showDenyButton: true,
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        denyButtonText: "Desfazer",
      }).then((modal) => {
        if (modal.isDenied) {
          this.$api
            .post(this.$endpoint.CANCEL_BINDING_REQUEST, {
              partner_name: name,
              binding_status: status,
            })
            .then((res) => {
              this.$swal({
                title: "Sucesso",
                text: res.data.msg,
                icon: "success",
                icon: "success",
                iconHtml: this.$icons.swal_success,
              });
              this.getBindings();
            })
            .catch((err) => {
              console.error(err);
              this.$swal("Erro", err.data.msg, "error");
            });
        }
      });
    },
    getBindings() {
      this.$api
        .get(this.$endpoint.GET_USER_BINDINGS)
        .then((res) => {
          this.bindings = res.data;
          // console.log(res.data);
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
  created() {
    this.getBindings();
  },
};
</script>

<style lang="scss">
.img {
  @apply bg-ontick-graphite-500 h-[52px] w-[52px] rounded-lg;
}
</style>
